import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import './index.scss';

/*
 * Wrapper for draggable components to be rendered as
 * content within a DraggableListItem, which provides
 * drag svg, common styling, etc.
 */
export function draggableListItemFactory(Component) {
  class DraggableListItem extends React.Component {
    render() {
      const {dragHandleProps, item} = this.props;
      return (
        <div className={`DraggableListItem`} style={{maxHeight: '100%'}}>
          <span {...dragHandleProps}>
            <SvgSymbol name={'dragUpDown'} />
          </span>
          <div className={'DraggableListItem-content'}>
            {React.createElement(Component, item)}
          </div>
        </div>
      );
    }
  }
  DraggableListItem.propTypes = {
    dragHandleProps: PropTypes.object,
    item: PropTypes.object,
  };
  return DraggableListItem;
}
